import baseUrl from "../config/baseUrl";

// Read-only: stored full-document OCR JSON for a document (null if not generated yet).
const getOcrFullData = async ({ token, documentId }) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/get-ocr-full-data?document_id=${encodeURIComponent(documentId)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return await response.json();
  } catch (error) {
    return error;
  }
};

export default getOcrFullData;
